<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-TingYuan`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.16953 6.08437L4.49645 4.46257C4.79653 4.09581 5.35731 4.09581 5.65739 4.46257L6.98431 6.08437C7.09395 6.21836 7.15384 6.38617 7.15384 6.5593V18.7531C7.15384 19.5816 6.48227 20.2531 5.65384 20.2531H4.5C3.67157 20.2531 3 19.5816 3 18.7531V6.5593C3 6.38617 3.05989 6.21836 3.16953 6.08437zM10.0933 6.08437L11.4202 4.46257C11.7203 4.09581 12.2812 4.09581 12.5812 4.46257L13.9081 6.08437C14.0178 6.21836 14.0776 6.38617 14.0776 6.5593V18.7531C14.0776 19.5816 13.4061 20.2531 12.5776 20.2531H11.4238C10.5954 20.2531 9.92383 19.5816 9.92383 18.7531V6.5593C9.92383 6.38617 9.98368 6.21836 10.0933 6.08437zM17.0153 6.08437L18.3422 4.46257C18.6423 4.09581 19.203 4.09581 19.5031 4.46257L20.8301 6.08437C20.9397 6.21836 20.9996 6.38617 20.9996 6.5593V18.7531C20.9996 19.5816 20.328 20.2531 19.4996 20.2531H18.3457C17.5173 20.2531 16.8457 19.5816 16.8457 18.7531V6.5593C16.8457 6.38617 16.9056 6.21836 17.0153 6.08437zM7.1543 9.46094H9.92355M7.1543 12H9.92355M7.1543 14.5391H9.92355M14.0762 9.46094H16.8454M14.0762 12H16.8454M14.0762 14.5391H16.8454" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconTingYuan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
